import React, { useEffect, useState } from 'react'
import SubHeader from '../Shared/Display/SubHeader'
import DateTimeFilter from '../Shared/Buttons/DateTimeFilter'
import FilterBy from '../Shared/Filters/FilterBy'
import CustomFilter from '../Shared/Buttons/CustomFilter'
import SearchWordCloud from '../Shared/Data/SearchWordCloud'
import SearchTermTable from '../Shared/Data/SearchTermTable'
import BannerImages from '../Shared/Data/BannerImages'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSearchTerms, fetchBannerContent } from '../Redux/Actions/Other'
import BackArrow from '../Shared/Icons/icon-backarrow-grey.svg'
import './Other.css'
import { componentCreated, updateDateFilter, updateGroupFilter } from '../Redux/Actions/DateFilter'
import { useLocation, useNavigate } from 'react-router'
import {
  composeFilterString,
  getDateFilter,
  getGroupFilter,
  processDate,
  processGroup,
  formatStartEndDates
} from '../utils/analytics-utils'
import { addQuery } from '../utils/router-utils'

/** @const {number} pageTotals */
const pageTotals = 10

function Other () {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [details, setDetails] = useState(false)
  const [page, setPage] = useState(1)

  const id = useSelector(state => state.account.ID)
  const searchTerms = useSelector(state => state.other.searchTerms)
  const bannerImages = useSelector(state => state.other.bannerImages)
  const dateFilterStore = useSelector(state => state.dateFilter)
  const name = 'Other'

  let dateFilterFromStore = getDateFilter(dateFilterStore, name)
  dateFilterFromStore = dateFilterFromStore ? dateFilterFromStore.dateFilter || 'Week' : 'Week'
  const [dateFilter, setDateFilter] = useState(dateFilterFromStore)

  const groupFilterFromStore = getGroupFilter(dateFilterStore, name) || ''
  const [groupFilter, setGroupFilter] = useState(groupFilterFromStore)
  const dateInterval = dateFilter ? dateFilter.dateInterval || null : null

  useEffect(() => {
    dispatch(componentCreated(name))
  }, [])

  useEffect(() => {
    update(processDate(dateFilter), processGroup(groupFilter))
  }, [page])

  useEffect(() => {
    newQuery(location.search.substring(1).split('&'))
  }, [])

  const newQuery = (query) => {
    const qobj = {}
    let newDateFilter
    query.forEach((q) => {
      qobj[q.split('=')[0]] = q.split('=')[1]
    })
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }
    update(processDate(newDateFilter), processGroup(groupFilter), id)
  }

  const update = (date, group, newID) => {
    const ID = newID || id
    const formattedDate = formatStartEndDates(date)
    dispatch(fetchSearchTerms(ID, formattedDate.start, formattedDate.end, {
      group: group.groups,
      profile: group.profiles,
      appType: group.alt
    }))
    dispatch(fetchBannerContent(ID, formattedDate.start, formattedDate.end, 'CAROUSEL', {
      group: group.groups,
      profile: group.profiles,
      appType: group.alt
    }))
  }

  const changeDateFilter = (newFilter, isCustom) => {
    if (isCustom) {
      dispatch(updateDateFilter(name, 'Custom', newFilter))
    } else {
      dispatch(updateDateFilter(name, newFilter))
    }
    const f = `${composeFilterString(groupFilter.profiles, groupFilter.groups)}_${groupFilter.alt || ''}`
    addQuery({ date: newFilter, filter: f }, location, navigate)
    setDateFilter(newFilter)
    if (newFilter !== 'Custom') {
      update(processDate(newFilter), processGroup(groupFilter))
    }
  }

  const changeGroupFilter = (newFilter) => {
    let newDateFilter
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }

    dispatch(updateGroupFilter(name, newFilter))
    const f = `${composeFilterString(newFilter.profiles, newFilter.groups)}_${newFilter.alt || ''}`
    addQuery({ date: newDateFilter, filter: f }, location, navigate)
    setGroupFilter(newFilter)
    update(processDate(newDateFilter), processGroup(newFilter))
  }

  let content = {}
  let title = ''
  if (!details) {
    content = <div className='flex justify-center'>
      <SearchWordCloud
        groupFilter={processGroup(groupFilter)}
        data={searchTerms}
        viewDetails={() => setDetails('search')}
      />
      <BannerImages
        groupFilter={processGroup(groupFilter)}
        data={bannerImages}
      />
    </div>
  } else if (details === 'search') {
    title = <div>
      <h2>
        <img src={BackArrow} className='interactive' alt='back' onClick={() => {
          setDetails(false)
          setPage(1)
        }} />
        Search Terms
      </h2>
    </div>
    content = <SearchTermTable
      data={searchTerms}
      changeOffset={(i) => { setPage(i) }}
      page={page}
      totalTerms={50 / pageTotals}
    />
  }
  return (
    <div id='otherActivity'>
      <div className='toolbar'>
        {details ? title : <SubHeader type='Other' />}
        <DateTimeFilter filterBy={changeDateFilter} currentFilter={dateFilter} />
        <div className='reportButtons'>
          {/* <FavoriteButton /> */}
          {/* <GenerateReportButton /> */}
        </div>
      </div>
      {(dateFilter !== 'Day' && dateFilter !== 'Week' && dateFilter !== 'Month')
        ? <CustomFilter
        filterBy={changeDateFilter} currentFilter={dateFilter} />
        : ''}
      <FilterBy changeFilter={changeGroupFilter} currentFilter={processGroup(groupFilter)} showProfiles showGroups type='App' />
      {content}
    </div>
  )
}

export default Other
